import React from 'react'
import Box from "@mui/material/Box";
import Description from "./Description";
import Tabel from './Tabel';
import { containerStyles } from "../style.js";

const HRDetail = () => {
  return (
    <Box id="" sx={containerStyles}>
     
    <Description />
   <Tabel/>
 
</Box>
  )
}

export default HRDetail
